var ajaxurl =   '/wp-admin/admin-ajax.php';
var winHeight =  window.innerHeight;

var cookieconsentModal = new bootstrap.Modal(document.getElementById('cookieconsent'), {
  keyboard: false,
backdrop: 'static', 
});

var recaptcha_response = '';
function isWindow( obj ) {
    return obj != null && obj === obj.window;
}
function getWindow( elem ) {
    return isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}
function offset( elem ) {
 
    var docElem, win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;

    docElem = doc.documentElement;

    if ( typeof elem.getBoundingClientRect !== typeof undefined ) {
        box = elem.getBoundingClientRect();
    }
    win = getWindow( doc );
    return {
        top: box.top + win.pageYOffset - docElem.clientTop,
        left: box.left + win.pageXOffset - docElem.clientLeft
    };
}; 

function findPos(obj) {
    var curleft = 0, curtop = 0;
    if (obj.offsetParent) {
        do {
            curleft += obj.offsetLeft;
            curtop += obj.offsetTop;
        } while (obj = obj.offsetParent);
        return { x: curleft, y: curtop };
    }
    return undefined;
}

function initMenu() {
    
    
    const mobileMenu = document.getElementById('navbarSupportedContent');
    var mobileMenuCollapse = new bootstrap.Collapse(mobileMenu, {
      toggle: false
    });
    
    
    const clickoutside = document.getElementById('clickoutside');
    
    
    mobileMenu.addEventListener('hidden.bs.collapse', function () {
        
        clickoutside.classList.remove('full');
        
    });
    
    mobileMenu.addEventListener('shown.bs.collapse', function () {
        
        clickoutside.classList.add('full');
        
    });
    
    clickoutside.addEventListener('click', function(){
        
        mobileMenuCollapse.hide();
    });
}

function testimonials() {
    
    const testimonialSection    = document.querySelector('.testimonilas-section');
    
    const testimonialContainer  = testimonialSection.querySelectorAll('.testimonial-container');
    
    const clicktriggers         = testimonialSection.querySelectorAll('.section-nav-link');
    
    const firstActive           =  testimonialSection.querySelector('.testimonial-container.active');
    const firstActiveSlide      =  firstActive.querySelectorAll('.swiper-slide');
    
    let i = 1; let index = 1;
    firstActiveSlide.forEach(function(slide){
        
        
        if (slide.classList.contains('this-active')) {
            
            index = i;
        }
        
         
        
        i++;
    });
    

    
    
    const firstSwiper   = firstActive.querySelector('.testimonialswiper');
          

    
    gsap.set(firstActive, {opacity: 1, y: 0, duration: 1, onComplete: function(){
                        
            const testimonialswiper = new Swiper(firstSwiper, {
                spaceBetween: 10,
                initialSlide: index,
                //observeParents: true,
               navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
              }); 


        } });
    
    
    
    clicktriggers.forEach(function(item) {
        
         item.addEventListener('click', function(){
             
             
                const cat = item.dataset.category;
             
                if (!item.classList.contains('active')) {
                    
                    
                    
                    testimonialContainer.forEach(function(container) {
                        
                        container.classList.remove('active');
                        gsap.to(container, {opacity: 0, y: 30, duration: 0});
                        
                    });
                    
                    const activeTab = testimonialSection.querySelector('.'+cat);
                    
                    activeTab.classList.add('active');
                    
                    const swiper   = activeTab.querySelector('.testimonialswiper');
    
                     
                    
                   
                    
                    gsap.to(testimonialSection.querySelector('.'+cat), 1.5, { ease: Power1.easeOuteaseOut, opacity: 1, y: 0, onComplete: function(){
                        
                        const testimonialswiper = new Swiper(swiper, {
                            //observeParents: true,
                            navigation: {
                              nextEl: ".swiper-button-next",
                              prevEl: ".swiper-button-prev",
                            },
                             spaceBetween: 10,
                            pagination: {
                                el: ".swiper-pagination",
                                clickable: true,
                            },
                          });
                        
                     
                    } });
                    
                 
                    
                     clicktriggers.forEach(function(trigger) {
                        
                         trigger.classList.remove('active');
                        
                    });
                    
                    this.classList.add('active');
                    
                   
                     
                }
        
                
        }); 
        
        
    });
    
   /*
    function initTicker() {
      
        // Rate = Distance over Time r=d/t
        // If we want to define the rate, and 
        // the distance is determined, 
        // time will have to be variable

        // We want to define the rate, and we can 
        // define that statically
        r = 30;
        adjustJank = 20; // Set this to 0 to see the jank I'm talking about ... this just adds to the distance animated to smooth out the seam

        // Get the initial scroll elements and save them for later
        const scrollElems = document.querySelectorAll('.wrapper h2');
        console.log(scrollElems);
        // Adjust our tween based on the object and distance given
        function adjustTween(obj, d) {
          // Get the progress of the previous tween if it exists
          let progress = 0;
          if(obj.tween) {
            progress = obj.tween.progress();
            // Kill the previous tween
            obj.tween.kill();
          }

          // r = d/t 
          // r*t = d
          // t = d/r

          // Set the proper time
          var t = d/r;

          // Create a new tween to animate our text so that it loops
          // Make sure to save it to the object so we can refer to it later
          obj.tween = gsap.fromTo(obj.parentElement, {x: 0}, {
            duration: t,
            x: "-"+(d+adjustJank), 
            ease: 'linear',
             force3D:true,
            repeat: -1,
          }).progress(progress); // Set the progress of the new tween to the same value of
                                 // the previous tween (if it exists) before it was killed
        }

        // Set up for what appears to be an seamless stream of text
        // This could go in an init() function
        scrollElems.forEach((obj, i) => {
          var d = obj.offsetWidth;
          var parent = obj.parentElement;
          var clone = obj.cloneNode(true);
          parent.appendChild(clone);
          gsap.set(parent.parentElement, {width: d});

          adjustTween(obj, d);
        });

        // Adjust widths and tweens on resize
        window.addEventListener("resize", () => {
          scrollElems.forEach((obj, i) => {
            var d = obj.offsetWidth;
            var parent = obj.parentElement;
            gsap.set(parent.parentElement, {width: d});
            adjustTween(obj, d);
          });
        });


      



        
    }
    
    initTicker();
 
 */
    
    
}

function initAnimateIn() {
    
    gsap.registerPlugin(ScrollTrigger);
    // For each images with class "animate-image" on page
    gsap.utils.toArray('.animate-in').forEach((el, index) => { 
        
       el.style.opacity = 0; 
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          toggleActions: "play none none reverse",
           //markers: true
        }
      })

      tl
      .set(el, {transformOrigin: 'center center'})
      .fromTo(el, { opacity: 0,  y: "+=70"}, {opacity: 1,  y: 0, duration: 1.2, delay:0.1, immediateRender: false})
    });
}

function initAnimateHeaderIn() {
    
    gsap.registerPlugin(ScrollTrigger);
    
    // For each images with class "animate-image" on page
    gsap.utils.toArray('.animate-in-img').forEach((el, index) => { 
       
       el.style.opacity = 0; 
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          toggleActions: "play none none reverse"
       
           
        }
      })

      tl
      .set(el, {transformOrigin: 'center center'})
      .fromTo(el, { opacity: 0,  y: "+=100"}, {opacity: 1,  y: 0, duration: 1.8, delay: 0.4, immediateRender: false})
    });
    
    
    
     gsap.utils.toArray(".entry-header-behandlungen").forEach((section, i) => {
     section.bg = section.querySelector(".container-header-img"); 

   

      section.bg.style.backgroundPosition = "0px 80px"; 

        gsap.to(section.bg, {
          backgroundPosition: `0px ${innerHeight / 6}px`,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top top", 
            end: "bottom top",
            scrub: true
          }
        });
    
    });
    
    
   
}

function initParallaxBgImg() {
    
   
    

    gsap.utils.toArray(".section-paralax .paralax-bg").forEach((section, i) => { 
        
      const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
        
       
 
        
        
      gsap.fromTo(section,{ 
        y: -heightDiff
      }, {
        scrollTrigger: {
          trigger: section,
          scrub: true
        },
        y: 0,
        ease: "none"
      });
    });
    

/*
    gsap.utils.toArray(".section-paralax").forEach((section, i) => {
      section.bg = section.querySelector(".paralax-bg"); 

    
  
     
        section.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;

        gsap.to(section.bg, {
          backgroundPosition: `50% ${-innerHeight / 8}px`,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            scrub: true
          }
        });
    
    });

*/


}

function SetUpAccordion() {
	
		
	       var accordionItems = document.querySelectorAll('.accordion-collapse');
    
   
    
            accordionItems.forEach(function(item){
                
                item.addEventListener('shown.bs.collapse', function () {
                    
                  
                   // alert();
                    var topY = offset(  this ).top - 250;  
                    
                   
                    TweenMax.to(window, 0, {
                        scrollTo:{
                            y: topY, 
                            //autoKill: true
                        }, 
                        ease:Power2.easeInOut
                     });
                    
                });
                
                
            });
    
			
	    
		


}


 function vaidateForm(){

		 var forms = document.querySelectorAll('.needs-validation');

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {

      console.log(form);
   
  
      function countCharacters(e) {

        var textEntered, countRemaining, counter;
        textEntered = form.querySelector('textarea').value;
        counter = (1000 - (textEntered.length));
        countRemaining = form.querySelector('.charactersRemaining');
  
          if (counter <= 10) {
  
              countRemaining.classList.add('text-danger');
              countRemaining.classList.remove('text-muted');
  
          } else {
              countRemaining.classList.remove('text-danger');
              countRemaining.classList.add('text-muted');
          }
  
        countRemaining.textContent = counter +'/1000';
      }
      
      form.querySelector('textarea').addEventListener('keyup', countCharacters, false);

      
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }

        form.classList.add('was-validated')
      }, false)
    })
}

function InitFormModal() {
    
    
    const formBut = document.querySelectorAll('.form-button');
    
    const terminBut = document.querySelector('.termin-button');

 

   
        
    
    const formmodal = new bootstrap.Modal(document.getElementById('contactModal'), {
      keyboard: false
    });
    
     const terminmodal = new bootstrap.Modal(document.getElementById('terminmodal'), {
      keyboard: false
    });
    
    
   
    
    
    document.getElementById('contactModal').addEventListener('shown.bs.modal', function (event) {
        vaidateForm('contactModal');
    })
    
    
    document.getElementById('terminmodal').addEventListener('shown.bs.modal', function (event) {

        vaidateForm('terminmodal');


    })
    
    
    formBut.forEach(function(but){
        
        
        but.addEventListener('click', function(e){
           
             e.preventDefault();
            
            formmodal.show();
            
            return false;
            
        });
        
    });
    

        
        
    terminBut.addEventListener('click', function(e){

         e.preventDefault();

        terminmodal.show();
        
        var winwidth =  window.innerWidth;
        
        if (winwidth < 992) {
            
            document.querySelector('.navbar-toggler').click();
        }

        return false;

    });


}

function InitCallModal() {
    
    
    const callBut = document.querySelectorAll('.call-button');
    
   
    
    const callModal = new bootstrap.Modal(document.getElementById('callModal'), {
      keyboard: false
    });
    
    
   
    
    
    callBut.forEach(function(but){
        
        
        but.addEventListener('click', function(e){
           
             e.preventDefault();
            
            callModal.show();
            
            return false;
            
        });
        
    });
}

function initCookieDisclaimer(){
				
				var exdays = 30;
				var $acceptAll =        document.querySelector('.btn-acceptAll');
				//var $acceptPart =       document.querySelector('.btn-AcceptPart');
				
				
				
				
				var cookieCheckTechnical = document.querySelector('#cookieconsent #cookieCheckTechnical');
				//var cookieCheckStatsitik = document.querySelector('#cookieconsent  #cookieCheckStatsitik');
				
				
				 setTimeout(function(){
					  cookieCheckTechnical.checked = true;
				  },1000);


				function setCookie(cname, cvalue, exdays) {
					var d = new Date();
					d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
					var expires = "expires="+d.toUTCString();
					document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
				}

				function getCookie(cname) {
					var name = cname + "=";
					var ca = document.cookie.split(';');
					for(var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
					c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {

					return c.substring(name.length, c.length);

					}
					}
					return ""; 
				}

				function injectScript(source) {
					
					var Script = document.createElement("script");
					var inlineScript = document.createTextNode(source);
					Script.appendChild(inlineScript); 
					document.getElementsByTagName('head')[0].appendChild(Script);

				
		
				}
				
				function technicalHook() {
					
					
				}
				
				function statsitikHook() {
					
					
                    loadGAonConsent();
                    loadFBonConsent();
				}
				
				function komfortHook() {
					
				
					
				}
				
				function checkCookie() {
					
					var cookieCheckTechnicalVal = getCookie('cookieCheckTechnicalVal');
					//var cookieCheckStatsitikVal = getCookie('cookieCheckStatsitikVal');
					
					
					
					
					if (cookieCheckTechnicalVal == 'true') {
						
						
						technicalHook();
						cookieCheckTechnical.checked = true;
					} else {
						
						cookieCheckTechnical.checked = false;
					}
                    /*
					
					if (cookieCheckStatsitikVal == 'true') {
						
						//statsitikHook();
						//cookieCheckStatsitik.checked = true;
						
					} else {
						
						cookieCheckStatsitik.checked = false;
						
						
					}
                    */
					
					
					
					
				}
				
                /*
				
				$acceptPart.addEventListener("click",function(e){
					
					
					var cookieCheckTechnicalVal 	= false;
					//var cookieCheckStatsitikVal 	= false;
					
					
					
					
					
					
					
					
					if (cookieCheckTechnical.checked) {
						
						cookieCheckTechnicalVal = true;
					}
                    
             
					
					if (cookieCheckStatsitik.checked) {
						
						cookieCheckStatsitikVal = true;
					}
               
					
					
					
					 setCookie('cookieCheckTechnicalVal', cookieCheckTechnicalVal, exdays);
					// setCookie('cookieCheckStatsitikVal', cookieCheckStatsitikVal, exdays);
					
					 setCookie('cookieConsent', true, exdays);
					 location.reload();
					
					cookieconsentModal.hide();
					
					
					
				},false);
				
				*/
				$acceptAll.addEventListener("click",function(e){
					
					
					var cookieCheckTechnicalVal 	= true;
					//var cookieCheckStatsitikVal 	= true;
					
					
					
					 setCookie('cookieCheckTechnicalVal', cookieCheckTechnicalVal, exdays);
					 //setCookie('cookieCheckStatsitikVal', cookieCheckStatsitikVal, exdays);
					
					 setCookie('cookieConsent', true, exdays);
					
					cookieconsentModal.hide();
					
					location.reload();
					
				},false);
				
				
				
				
				checkCookie();
				
				
				if (getCookie('cookieConsent').length) {
					
					
					
				} else {
					
					 cookieconsentModal.show();
					
				}
				
				
				


            } 
			 
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }
 


function verifyCaptcha(token) {
   
    recaptcha_response = token;

  
    document.getElementById('g-recaptcha-error').innerHTML = '';
}



function formSetup(ID) {


    
     const formholder = document.getElementById(ID);
     const form = formholder.querySelector('.needs-validation');
     const holder = form.querySelector('.holder');
     const submitButton = form.querySelector('.submit-button');
     const loader = form.querySelector('.loader');
     const textarea = formholder.querySelector('textarea');

     console.log(textarea);
    

     const erroralert = formholder.querySelector('.erroralert');
     const sendingalert = formholder.querySelector('.sendingalert');
     const successalert = formholder.querySelector('.successalert');
    
   
    
    function serialize(form) {
        if (!form || form.nodeName !== "FORM") {
                return;
        }
        var i, j, q = [];
        for (i = form.elements.length - 1; i >= 0; i = i - 1) {
            if (form.elements[i].name === "") {
                continue;
            }
            switch (form.elements[i].nodeName) {
                case 'INPUT':
                    switch (form.elements[i].type) {
                        case 'text':
                        case 'tel':
                        case 'email':
                        case 'hidden':
                        case 'password':
                        case 'button':
                        case 'reset':
                        case 'submit':
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            break;
                        case 'checkbox':
                        case 'radio':
                            if (form.elements[i].checked) {
                                    q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            }                                               
                            break;
                    }
                    break;
                    case 'file':
                    break; 
                case 'TEXTAREA':
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break;
                case 'SELECT':
                    switch (form.elements[i].type) {
                        case 'select-one':
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            break;
                        case 'select-multiple':
                            for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                                if (form.elements[i].options[j].selected) {
                                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value));
                                }
                            }
                            break;
                    }
                    break;
                case 'BUTTON':
                    switch (form.elements[i].type) {
                        case 'reset':
                        case 'submit':
                        case 'button':
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            break;
                    }
                    break;
                }
            }
        return q.join("&");
    }
    
    
    function SendForm() {
			
        const inputFinalize = formholder.querySelector('.finalize');

        inputFinalize.value = true;

        submitButton.classList.add('d-none');
        loader.classList.remove('d-none');
        

        var data = serialize(form); 
        
      

        setTimeout(function(){
            
            
            var request = new XMLHttpRequest();
      
            request.open('POST', ajaxurl, true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    
                   const responseHtml = this.response;
                    setTimeout(function(){
                        showSendingAlert(responseHtml);
                    },400);

                   


                } else {
                    
                    setTimeout(function(){
                        showSendingAlert('<div class="alert alert-danger lead">Das Formular konnte nicht verschickt werden.</div>');
                    },400);
                }
            };
            request.onerror = function() { 
                // Connection error
            };
            request.send('action=ajax_sand_form&'+data);    
            /*
            $.ajax({
                type : "POST",
                url: ajaxurl,
                data: {
                    action: "ajax_sand_form", 
                    formdata: data
                },

                success:function(html){

                    $('#loader').hide();
                    updateConfirmDialog(html);



                }
            });
            
            */
        },200);
	   
			
			
			
}


    function showSendingAlert(html) { 
        sendingalert.innerHTML = '';
        sendingalert.innerHTML = html;
        erroralert.classList.add('d-none'); 
        
        gsap.set(sendingalert, {opacity: 0});
        sendingalert.classList.remove('d-none');
        
         var topY = offset(formholder).top - 250;  
        
        TweenMax.to(window, 0.2, {
                scrollTo:{
                    y: topY, 
                    //autoKill: true
                }, 
                ease:Power2.easeInOut,
                delay: 0.9,
             });
        
        gsap.to(holder, 0.8, {height:0, ease:Power2.easeInOut, onComplete: function(){ 
        
           
            
            setTimeout(function(){
                
                 gsap.to(sendingalert, 0.2, {opacity:1, ease:Power2.easeInOut});
               
            },100)
            
            
            
            
        
        }});
        
       
                    
                   
        
        
     
            
           
        
    }
    

    
    function validationError() {
        
        
        var topY = offset(formholder).top - 250;  
                    
                   
        TweenMax.to(window, 0, {
            scrollTo:{
                y: topY, 
                //autoKill: true
            }, 
            ease:Power2.easeInOut
         });

        erroralert.classList.remove('d-none'); 
        sendingalert.classList.add('d-none');
        
       


    }

    function countCharacters(e) {

      var textEntered, countRemaining, counter;
      textEntered = textarea.value;
      counter = (1000 - (textEntered.length));
      countRemaining = document.getElementById('charactersRemaining');

        if (counter <= 10) {

            countRemaining.classList.add('text-danger');
            countRemaining.classList.remove('text-muted');

        } else {
            countRemaining.classList.remove('text-danger');
            countRemaining.classList.add('text-muted');
        }

      countRemaining.textContent = counter +'/1000';
    }
    
    textarea.addEventListener('keyup', countCharacters, false);

   
    
    
   form.addEventListener('submit', function (event) {
       
       
            
       
         
            /*if(recaptcha_response.length == 0) {
                
               
                
            } else {
                
                alert('jepp')
            }
            */

            event.preventDefault();
            event.stopPropagation();
       
       
            if (!form.checkValidity() || recaptcha_response.length == 0) {
                
          
                
                if ( recaptcha_response.length == 0) {
                    document.getElementById('g-recaptcha-error').innerHTML = '<span class="text-danger text-start">Bitte bestätigen Sie, dass die Eingabe nicht maschinell erfolgt.</span>';
                }
                 
                
                validationError();


		 		} else {
                    
                    SendForm();
                }
           


              form.classList.add('was-validated');

    }, false)
           
	
/*
    const validation = Array.prototype.filter.call(former, function(form) {

				
				if (form.checkValidity() === false) {
					

				  event.preventDefault();
				  event.stopPropagation();
					
					validationError();


		 		} else {
						  SendForm();
						

				}
				

				form.classList.add('was-validated');
				
				



			});
		
    */
    
}







if (document.querySelector('#contact-form')) {
    
  formSetup('contact-form');  
}


if (document.querySelector('.testimonilas-section')) {
    
  testimonials();  
}

if (document.querySelector('.animate-in')) {
    
  initAnimateIn();
}

if (document.querySelector('.section-paralax')) {
    
  initParallaxBgImg();
}

if (document.querySelector('.container-header-img')) {
    
  initAnimateHeaderIn();
}

if (document.querySelector('.accordion')) {
    
  SetUpAccordion();
}


     
 


if (document.querySelector('.call-button')) {
    
  InitCallModal();
}

if (document.querySelector('.needs-validation')) {
    
  vaidateForm();
}

initCookieDisclaimer();
InitFormModal();
initMenu();






